export const openingHourRoutes = {
	openingHourIndex: '/opening-hours',
	openingHourEdit: (id?: string) => `/opening-hours/${id ?? ':id'}`
} as const
